import React, { useEffect } from "react";
import {
  Card,
  rem,
  useLang,
} from "@manulife/mux";
import { useForm, FormProvider } from "react-hook-form";
import { NormalText } from "../../assets/appStyledComponents";
import useWindowSize from "../../customHooks/useWindowSize";
import RtgFormSection from "./RtgFormSection";

import Labels from "../../assets/labels";
import {
  addCurrencySign,
  getAmountNumbers,
} from "../../services/helpers/commonHelpers";

import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";
import { FormFocusProvider } from "../../customHooks/useFormFocus";


function RtgPageBody() {
  const { num30, num40, num15, num20, num480, num1280 } = NumberConstants;
  const selectedLang = useLang();
  const { width: windowWidth } = useWindowSize();

  let cardWidth = { width: "78vw" };
  if (windowWidth >= num1280) {
    cardWidth = { width: "47%" };
  }

  const methods = useForm({
    defaultValues: {
      rtgSelectedProduct: "",
      rtgCostType: "",
      rtgAmount: "",
      rtgAge: "",
      rtgSex: "",
      rtgHealthStyle: "",
      rtgSynClientName: "",
      rtgSynTermRiderAmount: "",
      rtgSynChildProtectionRiders: "",
      rtgSynChildCount: "",
      rtgSynChilds: [],
    },
    shouldFocusError: false 
  });

  const {
    formState: { isSubmitted },
    handleSubmit,
    trigger,
    getValues,
    setValue,
    watch,
    setFocus,
    control: { _names }
  } = methods;

  const rtgCostType = watch("rtgCostType");

  useEffect(() => {
    const amount1ToCheck = getAmountNumbers(
      getValues("rtgAmount") || 0,
      selectedLang
    );
    if (Number(amount1ToCheck) > 0) {
      setValue("rtgAmount", addCurrencySign(amount1ToCheck, selectedLang));
    }
    const amount2ToCheck = getAmountNumbers(
      getValues("rtgSynTermRiderAmount") || 0,
      selectedLang
    );
    if (Number(amount2ToCheck) > 0) {
      setValue(
        "rtgSynTermRiderAmount",
        addCurrencySign(amount2ToCheck, selectedLang)
      );
    }
    if (isSubmitted) {
      trigger();
    }
    return () => true;
  }, [selectedLang, rtgCostType, isSubmitted, trigger, getValues, setValue]);

  return (
    <Card customStyle={{ cardStyle: { marginBottom: `${rem(num30)}` } }}>
      <Card.Content
        customStyle={{
          contentStyle: {
            padding:
              windowWidth > num480 ? `${rem(num40)}` : `${rem(num15)}`,
          },
        }}
      >
        <NormalText>{Labels.text[`${selectedLang}`].label}</NormalText>
        <FormProvider {...methods}>
          <FormFocusProvider>
            <RtgFormSection
              cardWidth={cardWidth}
              num20={num20}
              num40={num40}
              handleSubmit={handleSubmit}
              setFocus={setFocus}
              fields={_names}
            />
          </FormFocusProvider>
        </FormProvider>
      </Card.Content>
    </Card>
  );
}

export default RtgPageBody;
